import React from "react";
import Button from "../../components/Button/Button";
import _404 from "../../images/404.svg";
import "./not-found.scss";

const NotFound = () => {
	return (
		<main className="not-found">
			<section className="not-found-left">
				<img src={_404} alt="404 illustration" />
			</section>
			<section className="not-found-right">
				<div className="not-found-right-text">
					<h2>Couldn't find what you were looking for...</h2>
					<p>
						The page you are searching for seems to under
						construction or does not exist.
					</p>
				</div>
				<div className="not-found-right-btn">
					<Button text="Home" link="/" variant="fill" color="black" />
					<Button
						text="Contact Us"
						link="/contact"
						variant="outline"
						color="black"
					/>
				</div>
			</section>
		</main>
	);
};

export default NotFound;
